import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pre-loader',
  templateUrl: './pre-loader.component.html',
  styleUrls: ['./pre-loader.component.scss'],
  standalone: false,
})
export class PreLoaderComponent {
  @Input() text?: string;
}
